import React from 'react';
import { Grid } from '@grnhse/seedling/lib/birch/layouts/grid';
import type { Item } from '@grnhse/seedling/lib/birch/components/forms/dropdown/item';
import {
  SingleDropdown,
  useSingleDropdown,
} from '@grnhse/seedling/lib/birch/components/forms/dropdown';
import { withLocalePrefix } from 'shared/utils/translation';
import IconButton from '@grnhse/seedling/lib/birch/components/buttons/icon_buttons';
import CloseIcon from '@grnhse/seedling/lib/birch/icons/close';
import FieldObject from './field_object';
import CustomFieldOptions from './custom_field_options';

const t = withLocalePrefix('talent_search.form.sections.candidate.labels');

type Props = {
  fieldObject: FieldObject;
  fetchFields: (term: string) => Promise<{ items: Item[] }>;
  fetchOptions: (id: string, term: string) => Promise<{ items: Item[] }>;
  onCustomFieldChange: (item: Item | null, index: number) => void;
  currencies: Item[];
  remove: () => void;
  index: number;
  isApplication?: boolean;
};

const CustomField = ({
  fieldObject,
  fetchFields,
  fetchOptions,
  onCustomFieldChange,
  currencies,
  remove,
  index,
  isApplication,
}: Props) => {
  const onChange = (e: { selectedItem?: Item | null }) => {
    onCustomFieldChange(e?.selectedItem || null, index);
  };

  const customFieldsDropdownProps = useSingleDropdown({
    fetchItems: fetchFields,
    selectedItem: fieldObject.customField,
    onSelectedItemChange: onChange,
    preventLoadOnMount: true,
  });

  const showOptions = !!fieldObject.customField;
  const placeholderLabel = isApplication
    ? t('application_field_placeholder')
    : t('custom_fields_placeholder');

  return (
    <Grid container alignItems={'center'} spacing={2}>
      <Grid item xs={11}>
        <SingleDropdown dropdownProps={customFieldsDropdownProps}>
          <SingleDropdown.Field
            data-provides={'talent-search-custom-field-dropdown'}
            ariaLabel={t('custom_fields')}
            placeholder={placeholderLabel}
            clearable={false}
          />
          <SingleDropdown.Flyout />
        </SingleDropdown>
      </Grid>

      <Grid item xs={1}>
        <IconButton icon={CloseIcon} label={t('delete')} onClick={remove} />
      </Grid>

      {showOptions && (
        <Grid item xs={12} sx={{ marginLeft: 3 }}>
          <CustomFieldOptions
            fetchOptions={fetchOptions}
            currencies={currencies}
            index={index}
            isApplication={isApplication}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default CustomField;
